import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;
export const HTTP_UNAUTHORIZED = 401;
export const ADMIN_LOGIN_PATH = '/admin/login';
export const PARTNER_LOGIN_PATH = '/partner/login';
export const CUSTOMER_LOGIN_PATH = '/customer/login';
// Kept for backward compatibility with earlier imports
export const LOGIN_PATH = ADMIN_LOGIN_PATH;
export const ADMIN_PATH_PREFIX = '/admin';
export const PARTNER_PATH_PREFIX = '/partner';
export const CUSTOMER_PATH_PREFIX = '/customer';

const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly session cookie
  headers: { 'Content-Type': 'application/json' },
});

/**
 * Decide which login page to bounce the user to when the current page
 * needs a session but doesn't have one. Public pages (Landing,
 * /customer/login, /customer/signup, /partner/login, etc.) return null,
 * which means "don't hijack the page".
 */
function getLoginPathForCurrentRoute() {
  if (typeof window === 'undefined') return null;
  const path = window.location.pathname || '';
  if (path.startsWith(ADMIN_PATH_PREFIX) && path !== ADMIN_LOGIN_PATH) {
    return ADMIN_LOGIN_PATH;
  }
  if (
    path.startsWith(PARTNER_PATH_PREFIX) &&
    path !== PARTNER_LOGIN_PATH &&
    !path.startsWith('/partner/signup')
  ) {
    return PARTNER_LOGIN_PATH;
  }
  if (
    path.startsWith(CUSTOMER_PATH_PREFIX) &&
    path !== CUSTOMER_LOGIN_PATH &&
    !path.startsWith('/customer/signup') &&
    !path.startsWith('/customer/payment/')
  ) {
    return CUSTOMER_LOGIN_PATH;
  }
  return null;
}

api.interceptors.response.use(
  (resp) => resp,
  (err) => {
    const status = err?.response?.status;
    if (status === HTTP_UNAUTHORIZED) {
      // Skip hard redirect for the `/auth/me` bootstrap probe — the
      // AuthProvider expects a 401 on first visit when no session exists, and
      // the Protected*Route components will handle the redirect declaratively
      // via <Navigate>. Forcing `window.location.href` mid-render here used
      // to race with React's rendering pipeline and trigger concurrent
      // rendering crashes.
      const requestUrl = err?.config?.url || '';
      const isAuthMeProbe = requestUrl.endsWith('/auth/me');
      if (!isAuthMeProbe) {
        const loginPath = getLoginPathForCurrentRoute();
        if (loginPath) {
          window.location.href = loginPath;
        }
      }
    }
    return Promise.reject(err);
  },
);

export default api;
